// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8a007da632f0e6b4967c","655":"1a137ecaac90a4da54df"}[chunkId] + ".js";
};